import { useLogMarketAnalyticsEvent } from '../../../hooks/useLogMarketAnalyticsEvent';
import { useCallback } from 'react';
import { useMarketRoute } from '../../../../../hooks/useMarketRoute';
import { useMarketDetail } from '../../../queries/useMarketDetail';
import { isNotNil } from 'shared/src/utils';

export const useLogClickShare = () => {
  const logMarketAnalytics = useLogMarketAnalyticsEvent();
  const { params } = useMarketRoute();

  const { data: marketDetail } = useMarketDetail(params.marketId);

  return useCallback(() => {
    if (!marketDetail) return;

    logMarketAnalytics({
      name: 'CLICK_SHARE_MARKET',
      analytics: {
        IS_FAVORITE: isNotNil(marketDetail.market.favorite) ? '1' : '0',
      },
    });
  }, [logMarketAnalytics, marketDetail]);
};
